<script setup>
import { ref } from 'vue';
import ContinueButton from './molecules/ContinueButton.vue';

const props = defineProps({
  options: {
    type: Array
  },
  title: {
    type: String
  }
});

const selectedOption = ref(null);
const selectedIndex = ref(null);

const emit = defineEmits(['selection']);

const getImgSrc = (imgPath) => {
  return new URL(`../assets/images/${imgPath}`, import.meta.url).href
}

const selectOption = (option, index) => {
  selectedOption.value = option.id;
  selectedIndex.value = index;
};

const handleContinue = () => {
  if (selectedIndex.value !== null) {
    emit('selection', selectedIndex.value);
  }
};
</script>

<template>
  <div class="component-container">
    <div class="component-card">
    <h2 class="heading-5">{{ title }}</h2>
    <div class="options-grid">
      <div
        v-for="(option, index) in options"
        :key="option.id"
        class="option-item"
        :class="{ 'selected': selectedOption === option.id }"
        @click="selectOption(option, index)"
      >
        <div class="option-icon-container">
          <img :src="getImgSrc(option.imgPath)" :alt="option.name" class="option-icon" />
        </div>
        <span class="option-name">{{ option.name }}</span>
      </div>
    </div>
    
  </div>
  <ContinueButton
    :disabled="selectedIndex === null"
    @click="handleContinue"
      class="continue-button"
    />
  </div>
</template>

<style scoped>
.heading-5 {
  font-size: 28px;
  padding-top: 16px;
  padding-bottom: 16px;
}

.company-selection {
  display: flex;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex: 1 0 0;
  align-self: stretch;
  
  border-radius: 32px;
  border: 1px solid var(--neutrals-200, #E2E4E9);
  background: var(--neutrals-0, #FFF);
}

.options-grid {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 4px;
  align-self: stretch;
  flex-wrap: wrap;
  width: 100%;
}

.option-item {
  display: flex;
  width: 100px;
  padding: 4px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  cursor: pointer;
}

.option-icon-container {
  display: flex;
  width: 80px;
  height: 80px;
  padding: 15.2px 20.8px;
  justify-content: center;
  align-items: center;
  border-radius: 65.6px;
  border: 0.8px solid var(--Web-Colors-Neutrals-200, #E2E4E9);
  background: #FFF;
  transition: border-color 0.2s ease;
}

.option-item.selected .option-icon-container {
  border-color: var(--primary-base, #3D2DF2);
  background-color: var(--primary-lighter, #EDF1FF);
  border-width: 2px;
}

.option-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  display: block;
}

.option-name {
  font-size: 14px;
  text-align: center;
}

.continue-button {
  margin-top: 20px;
  width: 100%;
}

@media (max-width: 768px) {
  .options-grid {
    gap: 4px;
  }
}

@media (max-width: 480px) {
  .company-selection {
    padding: 16px;
  }
}
</style> 